import { z } from 'zod';

export const signReceiptFormSchema = z.object({
  signReceiptNo: z.string().trim().min(1, '請填寫簽收單號'),
  signReceiptDate: z.string().min(1, '請填寫預計送交日'),
  /** 客戶關聯；write payload 送 customer_id（編輯僅變更時送）。 */
  customerId: z.string().optional().nullable(),
  /** UI-only：選了才帶入快照；不進 payload。 */
  contactId: z.string().optional().nullable(),
  customerName: z.string().optional().nullable(),
  contactName: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  fax: z.string().optional().nullable(),
  taxId: z.string().optional().nullable(),
  address: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  repairItemIds: z.array(z.string().min(1)).min(1, '請至少選一筆維修品項'),
});

export const SIGN_RECEIPT_FIELD_LABELS = {
  signReceiptNo: '簽收單號',
  signReceiptDate: '預計送交日',
  customerId: '客戶',
  contactId: '帶入聯絡人',
  customerName: '客戶名稱',
  contactName: '聯絡人',
  phone: '電話',
  fax: '傳真',
  taxId: '統編',
  address: '地址',
  remark: '備註',
  repairItemIds: '維修品項',
};
